import { FormGroup, ValidatorFn } from '@angular/forms';
import {Injectable } from '@angular/core';

// @Pipe({name: 'form'})
@Injectable()
export class FormPipe {

  public urlValidator = '(https?://)?([\\da-z.-]+)\\.([a-z.]{2,6})[/\\w .-]*/?';
  public fileSize = '5242880';

  public removeValidator(formGroup: FormGroup, property: string) {
    const control = formGroup.get(property);
    control.clearValidators();
    control.updateValueAndValidity();
  }

  public enableValidator(formGroup: FormGroup, property: string, validators: ValidatorFn[]) {
    const control = formGroup.get(property);
    control.setValidators(validators);
    control.updateValueAndValidity();
  }

  public removeValidators(formGroup: FormGroup) {
    // tslint:disable-next-line: forin
    for (const key in formGroup.controls) {
      formGroup.get(key).clearValidators();
      formGroup.get(key).setErrors(null);
      formGroup.get(key).updateValueAndValidity();
    }
  }
  //#endregion

  public setModel(formGroup: FormGroup, currentModel: any) {

    // tslint:disable-next-line: forin
    for (const key in formGroup.controls) {
      try {
        currentModel[key] = formGroup.controls[key].value;
      } catch (error) {
        throw error;
      }
    }
  }


  public findInvalidControls(formGroup: FormGroup) {

    const controls = formGroup.controls;
    for (const name in controls) {
      if (controls[name].invalid) {
        console.error(name);
      }
    }
  }

  public setForm(formGroup: FormGroup, currentModel: any) {
    // tslint:disable-next-line: forin
    for (const key in currentModel) {
      try {
        if (currentModel.hasOwnProperty(key)) {
          formGroup.controls[key].setValue(currentModel[key]);
        }
      } catch (error) {
        //    console.error(key);
      }
    }
  }
}


